fragment MixedStorySliderFragment on mixedStorySlider_Entry {
  id
  typeHandle
  heading
  backgroundGray
  stories {
    ...StoryPreviewFragment
  }
}
